import React from "react";
import ProductIcon from "./ProductIcons";
import InkAppCta from "./InkAppCta";

export default function ClosingCtaBanner({ title, body }) {
  return (
    <div className="flex flex-col gap-6 rounded-[28px] bg-ink px-6 py-7 text-white md:flex-row md:items-center md:justify-between md:px-8">
      <div className="flex items-start gap-4">
        <span className="mt-1 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/10 text-hint">
          <ProductIcon name="search" className="h-5 w-5" />
        </span>
        <div>
          <h3 className="text-2xl font-semibold tracking-display md:text-3xl">{title}</h3>
          <p className="mt-2 text-sm text-white/70">{body}</p>
        </div>
      </div>
      <InkAppCta inverted className="shrink-0">
        Get the app
      </InkAppCta>
    </div>
  );
}
